<template>
  <div class="payments-editor-costs">
    <divider orientation="left">Сведения о платеже</divider>
    <div class="payments-editor-costs__number">
      <row :gutter="16">
        <i-col span="24">
          <div class="ms-help label">
            Номер счета
          </div>
          <i-input
            :disabled="!getContractModulePerms('contract_payments', 'update')"
            v-model="payment.account_code"
            placeholder="Укажите номер счета"
          />
        </i-col>
      </row>
    </div>
    <div class="payments-editor-costs__payment-value">
      <row :gutter="16">
        <i-col span="12">
          <div class="ms-help label">
            Сумма платежа
          </div>
          <input-number
            size="default"
            v-model="payment.value"
            :min="0"
            :max="currentMaxValue"
            placeholder="Укажите сумму"
            :formatter="costsFormatter"
            :parser="costsParser"
            disabled
          />
        </i-col>
        <i-col span="12">
          <div class="ms-help label">
            Дата платежа
          </div>
          <date-picker
            size="default"
            format="dd.MM.yyyy"
            placeholder="Выберите дату"
            v-model="payment.date"
            :options="dateOptions"
            :disabled="!getContractModulePerms('contract_payments', 'update')"
          />
        </i-col>
      </row>
    </div>
  </div>
</template>

<script>
import { costsFormatter, costsParser } from '@/utils'

export default {
  props: ['payment', 'current-max-value'],
  methods: {
    costsFormatter,
    costsParser
  },
  data () {
    return {
      dateOptions: {
        disabledDate: (date) => {
          const start = new Date()

          return date && date.valueOf() > start.valueOf()
        }
      }
    }
  }
}
</script>

<style lang="less">
.payments-editor-costs {
  &__number {
    margin-bottom: 8px;
  }

  .ivu-input-number {
    width: 100%;
  }

  &__payment-value {
    margin-top: 8px;
  }
}
</style>
